import React from "react";
import { useTranslation } from "react-i18next";
import { useGlobalState} from "../GlobalContext";
import {StyledMenuItem} from "../common/menu/StyledMenu";
import {Divider} from "@mui/material"

const LanguageMenu = (props) => {
  const { i18n } = useTranslation();
  const { state } = useGlobalState();
  const handleClick = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("preservedState", JSON.stringify(state));
    window.location.reload();
  };

  const selectedLanguage =
    localStorage.getItem("beppoSelectedLanguage") || "DE";

  return (
    <>
      {(() => {
        const languages = ["DE", "EN", "FR", "IT"];
        const currentLanguage = selectedLanguage.toUpperCase();
        const availableLanguages = languages.filter(lang => lang !== currentLanguage);

        return availableLanguages.map((language, index) => (
            <React.Fragment key={language}>
              <StyledMenuItem
                  onClick={() => {
                    handleClick(language.toLowerCase());
                    localStorage.setItem("beppoSelectedLanguage", language.toLowerCase());
                    if (props.onClose) props.onClose();
                  }}
              >
                {language}
              </StyledMenuItem>
              {index < availableLanguages.length - 1 && (
                  <Divider sx={{ height: 0, borderColor: 'rgba(0, 0, 0, 0.02)' }} />
              )}
            </React.Fragment>
        ));
      })()}

    </>
  );
};

export default LanguageMenu;
